import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getPrefixApi, buildAuthHeaders, getCommonErrorCodesMap, handleApiError } from './utils';

export interface APICodeResponse {
  code: string;
  url: string;
}

export const getCode = async (flowApi: PlatformControllerFlowAPI) => {
  const { errorHandler, translations } = flowApi;
  const { t } = translations;
  const { withErrorHandler, getResolvedError } = errorHandler;
  const prefix = getPrefixApi(flowApi);
  
  try {
    return await withErrorHandler(
      async () => {
        const headers = buildAuthHeaders(flowApi);
        const { data } = await flowApi.httpClient.post<APICodeResponse>(
          `${prefix}/clubs/api/v1/invites`,
          headers,
          {},
        );
        return data;
      },
      {
        errorCodesMap: getCommonErrorCodesMap(t),
      },
    );
  } catch (error) {
    return handleApiError(error, getResolvedError, 'getCode', {
      code: '',
      url: '',
    });
  }
};
